import React, { useEffect, useState } from 'react'
import DisabilityComplaintModalUi from './DisabilityComplaintModalUi';
import { disabilityComplaintFetchByIdApi } from '../../apis/disabilityComplaint.api';
import { callApiAction } from '../../store/actions/commonAction';
import { useDispatch } from 'react-redux';
import { TransgenderComplaintFetchByIdApi } from '../../apis/transgender.api';
import TransgenderComplaintModalUi from './TransgenderComplaintModalUi';
import { poshComplaintFetchByIdApi } from '../../apis/poshPolicy.api';
import POSHComplaintModalUi from './POSHComplaintModalUi';
import { maternityFetchByIdApi } from '../../apis/maternity.api';
import MaternityComplaintModalUi from './MaternityComplaintModalUi';

const MaternityComplaintModalController = ({ id }) => {
    const [data, setData] = useState({})
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()

    console.log("object id modal", id);
    const fetchByIdMaternity = (id) => {
        setLoading(true);
        dispatch(
            callApiAction(
                async () => await maternityFetchByIdApi({ id }),
                async (response) => {
                    setData({...response});
                    console.log(" data and object", ...response);
                    setLoading(false);
                },
                (err) => {
                    setData({ ...data, err });
                    setLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        if (id) fetchByIdMaternity(id);
    }, [id]);

    return (
        <MaternityComplaintModalUi
            id={id}
            data={data}
            setData={setData}
            loading={loading}
        />
    )
}

export default MaternityComplaintModalController